import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {

  @Input() control: FormControl;
  @Input() options: AppRadioButtonModel[];
  @Input() showErrorLabel: boolean = true;
  @Input() customMessageError: string;
  @Input() title: string = "Selecione";
  
  @Output() onChange = new EventEmitter<any>();
  
  clickEvent(radioItem?: any) {
    this.onChange.emit(radioItem)
  }

  get isInvalid() {
    return (this.control && this.control.errors && (this.control.dirty || this.control.touched));
  }
}

export interface AppRadioButtonModel {
  label: string;
  value: any;
}